// The disclosures read to the patient with their consent to texts.
const CONSENT_DISCLOSURES = '(1) Msg & data rates may apply. (2) Msg frequency varies. (3) Reply STOP to any text message to opt out.';

export const visitReminders = {
  sectionTitle: 'Patient Appointment Reminders',
  sendTextLabel: (patientName: string) => `Send a text to ${patientName} about this appointment now`,
  sendRescheduleTextLabel: (patientName: string) => `Send a text to ${patientName} about this appointment reschedule now`,
  textMessagingDisabled: 'Text messaging is not enabled for this Patient.',
  phoneLabel: 'Phone',
  savePhone: 'Save',
  phoneSaved: 'Patient phone number updated successfully',
  phoneSaveFailed: 'Failed to update phone number',
  templateLabel: 'Message template',
  missingPharmacyAddressHint: 'Add the pharmacy address in Pharmacy Setup to use this template.',
  messageLabel: 'Message',
  messagePlaceholder: 'Type your text message here',
  previewLabel: 'Preview:',
  fetchConfigurationsFailed: 'Failed to fetch reminder settings. Please try again later.',
  appointmentReminders: {
    title: 'Appointment reminders',
    toggleLabel: 'Appointment reminders for this visit',
    on: 'Texts before this visit on these dates.',
    off: 'No appointment reminders for this visit. No-readings reminders are not affected.',
    // Followed by the Patient Settings shortcut ("Change this in Patient Settings.").
    locked: 'Text reminders are off for this patient.',
    // In a form with the consent checkbox, which turns them on.
    lockedUntilConsent: "Text reminders are off for this patient. Tick the patient's consent above to turn them on."
  },
  // The patient's consent to texts, shown in the visit forms and Patient Settings.
  textRemindersConsent: {
    label: 'Patient consents to text messages at the phone number above and was informed:',
    disclosures: CONSENT_DISCLOSURES,
    // Patient Settings' confirmation, where the number isn't above the checkbox.
    confirmation: (phone: string) => `Patient consents to text messages at ${phone} and was informed ${CONSENT_DISCLOSURES}`,
    savePhoneFirst: "Save the patient's phone number to record their consent.",
    // Patient Settings' confirmations for turning text reminders on and off.
    confirmationTitle: 'Patient Text Messaging Consent Confirmation',
    disableTitle: 'Disable Text Messaging Confirmation',
    disableMessage:
      'Are you sure you want to disable this setting? This action will prevent the sending of text messages to the patient without explicit consent.'
  },
  // The way from a locked visit form to Patient Settings and back (86eypxnvc).
  patientSettingsShortcut: {
    // Read as one sentence: "<changeIn> <link>."
    changeIn: 'Change this in',
    link: 'Patient Settings',
    refreshLabel: 'Refresh text reminder setting',
    stillOff: 'Text reminders are still off for this patient.',
    refreshFailed: "Couldn't check the text reminder setting. Please try again."
  },
  schedulePreview: {
    dayOf: 'Day of appointment',
    daysBefore: (days: number) => (days === 1 ? '1 day before' : `${days} days before`),
    noneConfigured: 'No appointment reminders are configured for this pharmacy.',
    chooseDate: 'Choose a date to see when the reminders go out.',
    tooSoon: (minDaysBefore: number) =>
      `This appointment is too soon for any appointment reminder to go out — the earliest configured reminder needs ${minDaysBefore} day(s) of notice.`,
    possiblyMissed: "Today's appointment reminders may have already gone out — this one could already be missed for today.",
    skipped: (count: number) =>
      `${count === 1 ? '1 earlier reminder' : `${count} earlier reminders`} won\'t go out — this appointment is too soon for ${
        count === 1 ? 'it' : 'them'
      }.`
  }
} as const;
